import React from "react";
import map from "assets/images/PakMap.png";

export const PakistanMap = () => {
  return (
    <div className="flex w-full justify-center">
      {/* <h1 className="text-bold">Geological Map</h1> */}
      {/* <img src={map} alt="Geological Map of Pakistan" /> */}
    </div>
  );
};
